<div class="container w-full">
  <form
    class="form mx-auto flex flex-col items-center justify-center"
    [formGroup]="reviewFormGroup"
    (ngSubmit)="emitSubmitEvent()">
    <ng-container *ngIf="shouldRenderReviewTnc">
      <label class="checkbox-container flex w-full">
        <mat-checkbox
          [ngClass]="invalidFormClass()"
          formControlName="acceptTnc">
        </mat-checkbox>
        <span
          class="checkbox-label cursor-pointer ltr:ml-2 rtl:mr-2"
          [innerHtml]="
            'transfer_v2.review.accept_tnc'
              | translate: termsTranslationParams()
          ">
        </span>
      </label>

      <p
        *ngIf="showErrorMessage()"
        class="error-message my-0 w-full ltr:ml-12 rtl:mr-12">
        {{ 'transfer_v2.review.please_agree_to_tnc' | translate }}
      </p>
    </ng-container>

    <rd-shared-button
      class="submit-button-wrapper mx-auto flex w-full items-center"
      [buttonClass]="'submit-button'"
      [buttonContent]="buttonContent"
      [buttonTheme]="'primary'"
      [buttonType]="'submit'"
      [isDisabled]="pointsTransferLoading || promocodeLoading">
      <ng-template #buttonContent>
        <span
          class="loading-text"
          *ngIf="
            pointsTransferLoading || promocodeLoading;
            else pointsTransferLoaded
          ">
          {{ 'transfer_v2.review.loading' | translate }}
        </span>
        <ng-template #pointsTransferLoaded>
          <span class="non-loading-text">{{
            'transfer_v2.review.submit_button_text' | translate
          }}</span>
        </ng-template>
      </ng-template>
    </rd-shared-button>
  </form>
</div>
